import { render, staticRenderFns } from "./OrderCleaning.vue?vue&type=template&id=2c94a6c7&scoped=true"
import script from "./OrderCleaning.vue?vue&type=script&lang=js"
export * from "./OrderCleaning.vue?vue&type=script&lang=js"
import style0 from "./OrderCleaning.vue?vue&type=style&index=0&id=2c94a6c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c94a6c7",
  null
  
)

export default component.exports